import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 12px;

  .logo {
    display: flex;
    width: 100%;
    justify-content: center;
    padding-top: 12px;
    padding-bottom: 18px;

    img {
      width: 180px;
    }
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  gap: 12px;
  width: 100%;

  .input-exchange {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 12px;
    border-radius: 6px;

    p {
      margin-top: 4px;
      margin-bottom: 4px;
    }

    .icon-flag {
      margin-right: 6px;
    }

    .createdAt {
      display: block;
      font-size: 11px;
      color: #eee;
      margin-bottom: 12px;
    }

    .currency-input {
      display: block;
      width: 90%;

      .inputtext {
        display: block;
        font-size: 18px;
        background: #1f2021;
        border-radius: 5px;
        padding-left: 8px;
        padding-right: 8px;
        padding-top: 6px;
        padding-bottom: 6px;
      }

      & + .currency-input {
        margin-top: 4px;
      }

      label {
        font-size: 12px;
        margin-bottom: 3px;
      }

    }
  }
`;
